<script>
export default {
    name : 'FormToggle',
    props:{
        titulo:{
            type: String,
            default: "",
        }
    },
    data(){
        return{
            selected : 0,
            options : [
                {value:1,label: 'Seif'},
                {value:2, label: 'Seif Modulos'},
                {value:3, label: 'Seif y Seif Modulos'},
            ]
        }
    },
    methods: {
    select(val) {
      this.$emit("input", val); 
      //console.log(val)
    }
  }
}
</script>

<template>
    <div class="d-flex flex-column aling-center">
        <label class="titleslight--text">{{ titulo }} <span class="titleslight--text font-weight-bold ml-1">*</span></label>
        
        <v-btn-toggle
        v-model="selected"
        class="my-2 mx-auto"
        rounded
        tile
        >
            <v-btn 
            v-for="option in options"
            :key="option.value"
            :value="option.value"
            class="px-4"
            depressed
            outlined
            :color="selected === option.value ? 'primary' : ''"
            @click="select(option.value)"
            >
            <v-icon
            left
            v-if="selected === option.value"
            color="black"
            >
                mdi-check
            </v-icon>
                {{ option.label }}
            </v-btn>
        </v-btn-toggle>
    </div>
</template>


